import { useEffect, useState } from 'react';
import { X } from '@phosphor-icons/react';

import * as Styled from './PreviewBanner.styles';

export interface PreviewBannerProps {
  /**
   * A unix date of when the preview expires.
   */
  exp: number;
}

const PreviewBanner = ({ exp }: PreviewBannerProps) => {
  const [showPreviewLabel, setShowPreviewLabel] = useState(true);
  const [isExpired, setIsExpired] = useState(false);
  const [countDown, setCountDown] = useState<Date>();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      if (now > exp * 1000) {
        setIsExpired(true);
        clearInterval(interval);
        return;
      }
      setCountDown(new Date(exp * 1000 - now));
    }, 1000);

    return () => clearInterval(interval);
  }, [exp]);

  if (!showPreviewLabel) {
    return null;
  }

  return (
    <Styled.Container $style='uiTextSmall' as='div'>
      Preview
      {countDown && !isExpired && (
        <Styled.Countdown>{countDown.toISOString().replace(/.+T/, '').slice(0, 8)}</Styled.Countdown>
      )}
      {isExpired && <Styled.Expired>expired</Styled.Expired>}
      <Styled.Button onClick={() => setShowPreviewLabel(false)}>
        <X weight='bold' size='12' />
      </Styled.Button>
    </Styled.Container>
  );
};

export default PreviewBanner;
